import Auth from '@js/plugins/auth';

export default {
    computed: {
        canManageOrderLayout() {
            return Auth.hasPermissionTo('franchise_manage_order_grid_layout');
        },

        canManageOrderDisplayGroup() {
            return Auth.hasPermissionTo('franchise_manage_order_display_group');
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/order-layout/order-layout-permission.js